<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">FAQs</h1>
            </div>
            <div>
                <button class="btn-tertiary" type="button" @click="navigateToCategories">Manage Categories</button>
                <button class="btn-primary" type="button" @click="createArticle">Create Article</button>
            </div>
        </div>

        <input type="text" v-model="$root.persist.articlesSearch" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Article" @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="60%">Title</div>
                <div class="results-head" data-width="30%">Category</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectedArticle(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell truncate" data-width="60%">{{ result.title }}</div>
                    <div class="results-cell truncate" data-width="30%">{{
                            result.category ? result.category.name : ''
                        }}
                    </div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import faqView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'FAQ',
    props: {
        //
    },
    data() {
        return {
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        faqView,
    },
    mounted() {
        if (!this.$root.persist.articlesSearch) {
            window.setTimeout(function () {
                this.$refs.searchbar.focus()
            }.bind(this), 100)
        } else {
            this.handleSearch()
        }

        this.setMetaTitle('List FAQ Articles | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('faq.list'), {
                params: {
                    term: this.$root.persist.articlesSearch,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of an Article
         *
         * @param  {Object}
         * @return {void}
         */
        handleSelectedArticle(article) {
            this.$router.push({name: 'faq.show', params: {faqId: article.id}})
        },
        /**
         * Create a new Article
         *
         * @return {void}
         */
        createArticle() {
            this.$router.push({name: 'faq.create'})
        },
        /**
         * Navigate to manage Categories
         *
         * @return {void}
         */
        navigateToCategories() {
            this.$router.push({name: 'faq.categories.list'})
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'faq.list') {
            this.setMetaTitle('List FAQ Articles | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newArticle) {
            window.setTimeout(() => {
                this.handleSelectedArticle(to.params.newArticle)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">

</style>
